export enum UploadFileType {
  COURSE_SUMMARY_NOTE = 'COURSE_SUMMARY_NOTE',
  COURSE_SUMMARY_HOMEWORK = 'COURSE_SUMMARY_HOMEWORK',
  COURSE_SUMMARY_VIDEO = 'COURSE_SUMMARY_VIDEO',
}
